import React, { useMemo } from 'react';
import { useField } from 'formik';

import ColiEco from './Methods/ColiEco';
import StandardPackage from './Methods/StandardPackage';
import Relay from './Methods/Relay';
import Colissimo from './Methods/Colissimo';
import MondialRelay from './Methods/MondialRelay';
import ShippingMethod from 'model/ShippingMethod';
import useDeliveryMethods from 'hooks/checkout/useDeliveryMethods';
import { Cart } from 'types/Cart';
import { ShippingFormType } from 'types/ShippingFormType';

export default function ShippingMethods({
  cart,
  setShippingInformation,
  className,
}: {
  cart: Cart;
  setShippingInformation: (
    params: Partial<ShippingFormType>
  ) => Promise<Cart | undefined>;
  className?: string;
}): JSX.Element {
  const { methods } = useDeliveryMethods();
  const [field] = useField({ name: 'shippingMethod' });
  const componentMethods = useMemo(
    () => ({
      [ShippingMethod.relay]: Relay,
      [ShippingMethod.colissimo]: Colissimo,
      [ShippingMethod.colieco]: ColiEco,
      [ShippingMethod.standardPackage]: StandardPackage,
      [ShippingMethod.mondialRelay]: MondialRelay,
    }),
    []
  );

  return (
    <div className={className}>
      {methods?.map(method => {
        if (componentMethods[method.methodCode]) {
          const Component = componentMethods[method.methodCode];

          return (
            <Component
              key={method.methodCode}
              method={method}
              cart={cart}
              isSelected={field.value === method.methodCode}
              setShippingInformation={setShippingInformation}
            />
          );
        }
      })}
    </div>
  );
}
